export default __webpack_public_path__ + "static/media/sadface.d77cefa8.png";